import { render, staticRenderFns } from "./TagPopup.component.vue?vue&type=template&id=79e93136&scoped=true&"
import script from "./TagPopup.component.vue?vue&type=script&lang=js&"
export * from "./TagPopup.component.vue?vue&type=script&lang=js&"
import style0 from "./TagPopup.component.vue?vue&type=style&index=0&id=79e93136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e93136",
  null
  
)

export default component.exports